<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Partnering'"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">
					Innovative Partnerships Built to Last
				</div>
				<div class="txt" style="text-align: center;">
					Share the passion and vision—collaborate with CorDx.
				</div>
				<div class="bg_box">
					<img src="../../assets/img_h5/img01-@2x.webp" />
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="mark"></div>
				<div class="block_2_el">
					<img class="bg" src="../../assets/img_h5/图像 11@2x.webp" />
					<div class="tit">What We Look For</div>
					<div class="txt">
						CorDx partners with organizations around the world to develop, manufacture, and supply diagnostics that empower users to monitor and improve their health. We prioritize partnerships that create benefits and make a difference for caregivers and patients alike. Our partners share our passion and vision for scientific innovation with collaboration, insight, and effectiveness.
					</div>
				</div>
				<div class="block_2_el">
					<img class="bg" src="../../assets/img_h5/img@2x.webp" />
					<div class="tit">Built to Last</div>
					<div class="txt">
						We invest in partnerships that are built to last. Each relationship is carefully built on trust, transparency, and a shared goal of innovation and client benefit. From our first interaction, we strive to ensure that both parties’ needs are met. At each stage, we collaboratively evaluate our actions and modify our approach as necessary to meet our mutual goals.
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块5-->
			<div class="block_5"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">Our Partners</div>
				<div v-for="(value, index) in linkData" :key="index" class="block_5_el" @click="goWeb(value.href)">
					<div class="img_box">
						<img :src="value.image" :style="'width:' + value.width + 'px;'" />
					</div>
				</div>
			</div>
			<!--块5-->
			<!--块6-->
			<div class="block_6"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">
					ANTI-BRIBERY<br />
					& ANTI-CORRUPTION POLICY
				</div>
				<img src="../../assets/img_h5/tf_bg.webp" @click="goPDF" />
			</div>
			<!--块6-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">Propose a Partnership</div>
				<div class="txt">
					Join us and change the world of diagnostics
				</div>
				<div class="btn_box_f">
					<div class="btn_box_ty btn_box" @click="goContact">
						Contact Us<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
				</div>
				<div class="bg_box">
					<img src="../../assets/img_h5/背景图@2x.webp" />
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">Recent News</div>
				<div class="news_box">
					<div class="icon_left animate__animated animate__fadeInLeft" @click="bannerLeftClick">
						<van-icon name="arrow-left" color="#ffffff" size="21px" />
					</div>
					<div class="icon_right animate__animated animate__fadeInRight" @click="bannerRightClick">
						<van-icon name="arrow" color="#ffffff" size="21px" />
					</div>
					<van-swipe class="my-swipe" :show-indicators="true" :loop="true" :autoplay="3000" indicator-color="#0B318F" ref="swipeDom2" :stop-propagation="false">
						<van-swipe-item v-for="(value, index) in newsData" :key="index">
							<div class="swiper_el" @click="goResourcesInfo(value)">
								<img class="bg" :src="value.image" />
								<div class="txt_box">
									<div class="tit">{{ value.title }}</div>
									<div class="time">{{ value.fabu_time }}</div>
								</div>
							</div>
						</van-swipe-item>
					</van-swipe>
				</div>
				<div class="btn_box_f">
					<div class="btn_box_ty btn_box" @click="goResources">
						View More<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块4-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			linkData: [
				{ id: 1, image: require('@/assets/img_public/Partner_07.png'), width: 180, title: 'CorDx', text: 'Diagnostic platform for innovation, manufacturing, and supply.', href: 'https://www.hsa.gov.sg/', },
				{ id: 2, image: require('@/assets/img_public/Partner_02.png'), width: 240, title: 'Core tests', text: 'Precision, reliable, and use-friendly testing solutions for IVD and more.', href: 'https://www.gatech.edu/', },
				{ id: 3, image: require('@/assets/img_public/Partner_03.png'), width: 210, title: 'Jtests', text: 'Raw materials for diagnostic research, development, and production.', href: 'https://tyfast.energy/', },
				{ id: 4, image: require('@/assets/img_public/Partner_04.png'), width: 220, title: 'Abiores', text: 'PCR solutions for diagnostic testing, research, and development.', href: 'https://ucsd.edu/', },
				{ id: 5, image: require('@/assets/img_public/Partner_08.webp'), width: 210, title: 'Bono Plastics', text: 'Consumable supplies and resources for diagnostic production and development.', href: '/scientific-strategy-board', },
				{ id: 6, image: require('@/assets/img_public/Partner_06.png'), width: 145, title: 'CuPet', text: 'One-Stop Animal Diagnostic Solutions.', href: 'https://www.nih.gov/', },
			],
			newsData: JSON.parse(sessionStorage.getItem('newsData')),
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击进去新闻详情
		goResourcesInfo(value) {
			let that = this;
			//that.$router.push({ path: '/resources-info', query: { id: value.unionid, } });
			that.$router.push({ name: 'Resourcesinfo', params: { resourcesInfoId: value.custom, } });
		},
		bannerLeftClick(value) {  //导航左侧按钮点击
			let that = this;
			that.$refs.swipeDom2.prev();
		},
		bannerRightClick(value) {  //导航右侧按钮点击
			let that = this;
			that.$refs.swipeDom2.next();
		},
		goContact() {
			this.$router.push({ path: '/contact', });
		},
		goResources() {
			this.$router.push({ path: '/resources', });
		},
		//跳转外站
		goWeb(value) {
			let that = this;
			if(value == '/scientific-strategy-board') {
				that.$router.push({ path: value });
			}else {
				window.location.href = value;
			}
		},
		//跳转反贿赂&贪腐
		goPDF() {
			let that = this;
			that.$router.push({ path: '/ANTI-BRIBERY-AND-ANTI-CORRUPTION-POLICY' });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	//块6
	.block_6{
		padding-top: 64px;
		.tit{
			padding-bottom: 30px;
			font-size: 22px;
			text-align: center;
		}
		img{
			width: 100%;
		}
	}
	/*块5*/
	.block_5{
		padding: 50px 20px 0px 20px;
		.block_5_el{
			margin-top: 36px;
			height: 200px;
			padding: 16px 20px 30px 20px;
			background-color: #ffffff;
			box-shadow: 0 0 8px rgb(230, 230, 230, 0.2);
			border-radius: 5px;
			position: relative;
			.img_box{
				width: 100%;
				margin: 0 auto;
				img{
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
				}
			}
		}
		.text{
			padding-top: 16px;
			font-size: 18px;
		}
		.title{
			font-size: 26px;
		}
	}
	/*块4*/
	.block_4{
		padding: 42px 20px 120px 20px;
		background-image: linear-gradient(180deg, #F1ECE6 20%, #FFFFFF 100%);
		.btn_box{
			margin: 42px 0 0 0;
		}
		.news_box{
			.swiper_el{
				padding-bottom: 25px;
				background-color: #FFFFFF;
				//box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
				.txt_box{
					padding: 20px;
					.time{
						padding-top: 30px;
						font-size: 18px;
						color: #706B69;
					}
					.tit{
						font-size: 22px;
					}
				}
				img.bg{
					width: 100%;
					height: auto;
					object-fit: cover;
				}
			}
		}
		.title{
			padding-bottom: 24px;
			font-size: 42px;
		}
	}
	/*块3*/
	.block_3{
		padding-top: 64px;
		text-align: center;
		.bg_box{
			img{ width: 100%; }
		}
		.btn_box{
			margin: 42px 0 15px 0;
		}
		.txt{
			padding: 10px 30px 0 30px;
			font-size: 20px;
		}
		.tit{
			padding: 0 20px;
			color: #3D3D3D;
			font-size: 42px;
		}
	}
	/*块2*/
	.block_2{
		position: relative;
		padding: 0 20px 0 20px;
		.mark{
			position: absolute;
			top: 0;
			left: 0;
			z-index: -1;
			width: 100%;
			height: 95%;
			background-image: linear-gradient(180deg, #FFFFFF 20%, #F1ECE6 100%);
		}
		.block_2_el{
			background-color: #FFFFFF;
			box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
			.btn_box{
				margin: 42px 0 50px 0;
			}
			.txt{
				padding: 30px 16px;
				font-size: 18px;
			}
			.tit{
				padding: 20px 16px 0 16px;
				font-size: 24px;
			}
			img.bg{
				width: 100%;
			}
		}
	}
	/*块1*/
	.block_1{
		padding: 22px 0 0 0;
		color: #3D3D3D;
		.bg_box{
			padding-bottom: 42px;
			img{ width: 100%; }
		}
		.txt{
			padding: 0 20px 30px 20px;
			font-size: 20px;
		}
		.tit{
			text-align: center;
			padding: 0 20px;
			font-size: 42px;
		}
	}
}
</style>
